import dayjs from 'dayjs';

const formatDate = (date: Date | null, format: string = 'YYYYMMDD'): string | null => {
  return date ? dayjs(date).format(format) : null;
};

export default formatDate;
